import {Screen} from '#component/base';
import {
  AccordionSection,
  Hero,
  InfoCTA,
  InfoHeader,
  InternalNavBar,
  ReferenceSection,
} from '#component/partial';
import {sprinkles} from '#style/sprinkles';

import {HowItWorks} from './components';
import {infoCTAData, infoHeader, links, references, terminology} from './UnderstandingYourAge.util';

export const UnderstandingYourAge = () => (
  <Screen pageName="Understanding Your Age" withDefaultSizing={false} hideHeader>
    <InternalNavBar links={links} />

    <Hero variant="ecruWhite" id="overview" showScrollIndicator>
      <InfoHeader {...infoHeader} />
    </Hero>

    <section className={sprinkles({pY: [48, 72, 144]})} id="terminology">
      <AccordionSection {...terminology} />
    </section>

    <section className={sprinkles({bg: 'ecruWhite', pY: [48, 72, 144]})} id="how-it-works">
      <HowItWorks />
    </section>

    <section className={sprinkles({pY: [48, 72, 144]})} id="lifestyle-factors">
      <InfoCTA {...infoCTAData} />
    </section>

    <section
      className={sprinkles({bg: 'springWood', pX: [0, 24, 32], pY: [48, 72, 144]})}
      id="learn">
      <ReferenceSection references={references} />
    </section>
  </Screen>
);
